import loadUrlModule from './modules/Url.module';
import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
const loadMobileNavigationModule = () => ({
    hasRouter: false,
    modules: [loadUrlModule(), loadSessionModule(), loadAuthenticationModule(), loadCookieConsentModule()],
});
export default loadMobileNavigationModule;
